import styled from 'styled-components';

export const SearchInputBlock = styled.div`
  width: 70%;
  margin: 10px auto;
  display: flex;
`;

export const CreateUserButton = styled.div`
  width: 30%;
  margin-left: 10px;
`;

export const ParamsName = styled.div`
  font-size: 14px;
  width: 100px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const ParamsBlock = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 7px;
  width: 300px;
`;

export const ParamsColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid #e8e9e9;
  width: 35%;
`;

export const ParamsContent = styled.div`
  display: flex;
  justify-content: space-around;
   width: 75%;
  margin: 0 auto;
 
`;

export const ParamsTagsColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid #e8e9e9;
  width: 65%;
  // margin-left: 5px;
`;

export const FitnessFuncContent = styled.div`
  width: 70%;
  margin: 10px auto;
`;

export const HeaderName = styled.div`
  display: flex;
  align-items: flex-start;
  font-size: 12px;
`;

export const ParamsTagsBlock = styled.div`
  display: flex;
  // width:  420px;
  width: 100%;
  flex-direction: column;
  justify-content: center;

  padding: 5px;
`;

export const ParamsTagsName = styled.div`
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 10px auto;
`;

export const ButtonBlock = styled.div`
  width: 70%;
  margin: 10px auto;
  display: flex;
  justify-content: center;
`;

export const MenuTagName = styled.p`
  margin-left: 10px;
`;

export const MenuTagNameDisabled = styled.p`
  margin-left: 10px;
  color: #a0a0a0;
`;

export const Label = styled.label`
  display: flex;
  cursor: pointer;
  align-items: center;
  width: 100px;
`;
export const TimeLabel = styled.label`
display: flex;
cursor: pointer;
align-items: center;
width: 100%;
background-color: white;
font-size: 14px;
margin-left: 15px;
// border: 1px solid grey;
`

export const ResultInfoBlock = styled.div`
  position: relative;
  cursor: pointer;
  width: 100%;
  height: 50px;
  text-align: center;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  background: #fff;
  box-sizing: border-box;
  border-bottom: 1px solid #c1c1c1;
  @media (max-width: 992px) {
    padding: 0 160px 0 55px;
  }
  @media (max-width: 768px) {
    height: auto;
    padding: 20px 10px 60px;
  }
  @media (max-width: 500px) {
    font-size: 24px;
  }
  @media (max-width: 350px) {
    font-size: 20px;
  }
`;

export const ResultContent = styled.div`
  width: 85%;
  margin: 0 auto;
  border: 1px solid #c1c1c1;
  margin-bottom: 10px;
`;

export const H1 = styled.h1`
  text-align: center;
  font-size: 20px;
  margin-top: 25px;
`;

export const ResultHeaderBlock = styled.div`
  width: 80%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ResultHeaderName = styled.p`
  font-size: 16px;
  margin-bottom: 0;
`;

export const InfoBlock = styled.div`
  // margin: 0 auto;
  display: flex;
  justify-content: flex-start;
  color: grey;
  font-size: 12px;
`;

export const FooterBlock = styled.div`
  height: 50px;
`;

export const FFLimitBlock = styled.div`
  margin: 0 auto;
  margin-top: 5px;
  width: 35%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const FFLimitLabel = styled.p`
  margin-right: 10px;
  width: 180px;
  font-size: 14px;
  margin-bottom: 0;
`;

export const GenerationModeBlock = styled.div`
  margin: 0 auto;
  width: 35%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const GenerationModeLabel = styled.p`
  margin-right: 10px;
  width: 180px;
  font-size: 14px;
  margin-bottom: 0;
`;

export const TitleOfCbju = styled.div`
  display: flex;
  font-size: 12px;
  flex-direction: row;
  justify-content: space-between;
  height: 10px;
`;



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/UserPage/userPageStyles.js